import siteMessage from "@insite/client-framework/SiteMessage";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { ToastContextData } from "@insite/mobius/Toast/ToasterContext";
import { useEffect, useState } from "react";

const enterKey = 13;

const useAccessibleSubmit = (value: string, onSubmit: (value: string) => void, cartLine: CartLineModel, toasterContext: ToastContextData, cartLoadedTime?: number) => {
    const [stateValue, setValue] = useState(value);
    const changeHandler = (event: any) => {
        const value = event.target.value.replace(/^0+/, '');

        if ((cartLine.properties.cartLineCondition.toLowerCase() === "open box" || cartLine.properties.cartLineCondition.toLowerCase() === "used") && (Number(value) > cartLine.qtyOnHand)) {
            toasterContext.addToast({ body: siteMessage("Core_NotEnoughStockError"), messageType: "danger" });
            return;
        }
        setValue(value);
    };

    const [isOnSubmitCalled, setIsOnSubmitCalled] = useState(false);
    const callOnSubmitSafety = (value: string) => {
        if (!isOnSubmitCalled) {
            setIsOnSubmitCalled(true);
            onSubmit(value);
        }
    };

    const keyDownHandler = (event: any) => {
        if (event.keyCode === enterKey) {
            event.stopPropagation();
            callOnSubmitSafety(stateValue);
        }
    };

    const blurHandler = () => {
        if (value !== String(stateValue)) {
            callOnSubmitSafety(stateValue);
        }
    };

    useEffect(() => {
        setValue(value);
        setIsOnSubmitCalled(false);
    }, [value, cartLoadedTime]);

    return {
        value: stateValue,
        changeHandler,
        keyDownHandler,
        blurHandler,
    };
};

export default useAccessibleSubmit;
